let IntentosPost5 = 0;
const PostXls = (urlB, body, nombre, resp) => {
    fetch(urlB, {
        method: 'POST',
        body: JSON.stringify(body),
        headers:{'Content-Type' : 'application/json', 'charset' : 'UTF-8'},})
    .then(response => response.blob())
    .then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = `${nombre}.xls`;
        document.body.appendChild(a)
        a.click(); 
        a.remove();
        resp("ok")
    },error => {
        IntentosPost5++;
        (IntentosPost5 > 5) ? IntentosPost5 = 0 : PostXls(urlB, body, nombre, (respuesta) => {
            resp(respuesta)
        })
        console.error('Ocurrió un error al cargar. Reintentando. ', error);
    })
}

export default PostXls;


// WEBPACK FOOTER //
// ./src/shared/PostXls.jsx